import React, { useState } from "react";
import { Divider, Grid, Typography } from "@material-ui/core";

// import { EditorState } from "draft-js";
// import { Editor } from "react-draft-wysiwyg";
// import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useQuery, useMutation, useLazyQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { Card, CardActions, CardContent } from "../../components/Card";
import Button from "../../components/Button";
import { TextInput } from "../../components/Form";
import { useAlert } from "../../components/Alert";

const SAVE_SECRET = gql`
  mutation saveSecret($secretInput: SecretInput!) {
    saveSecret(secretInput: $secretInput)
  }
`;

export default function AddSaleSecretForm({ onChangeSelect = () => {} }) {
  const Alert = useAlert();
  // const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [newData, setNewData] = useState({
    title: "",
    content: "",
  });
  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  const [saveSecret, { loading }] = useMutation(SAVE_SECRET, {
    onCompleted({ saveSecret }) {
      if (saveSecret) {
        Alert.alert("", "儲存成功", [
          {
            text: "確定",
            onPress: () => {
              onChangeSelect();
            },
            type: "ok",
          },
        ]);
      } else {
        Alert.alert("", "儲存失敗，請再次嘗試。", [
          { text: "確定", type: "ok" },
        ]);
      }
    },
    onError(error) {
      Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
    },
  });

  function save() {
    const secretInput = {
      questionerId: Number(localStorage.getItem("@fullhouseUserId")),
      title: newData.title,
      content: newData.content,
    };
    saveSecret({ variables: { secretInput } });
  }

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} justify="center">
          <Grid item sm={5}>
            <Typography color="primary"> 標題</Typography>
            <TextInput
              value={newData.title}
              onChange={(e) => changeData("title", e, true)}
              fullWidth
            />
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <Grid xs={12} sm={12}>
          <Typography color="primary"> 內容</Typography>
          <TextInput
            value={newData.content}
            rows={10}
            multiline
            onChange={(e) => changeData("content", e, true)}
            fullWidth
          />
          {/* <Editor
            toolbar={{
              options: ["fontSize", "colorPicker", "image", "link"],
            }}
            initialEditorState={editorState}
            toolbarClassName="toolbar"
            wrapperClassName="wrapper"
            editorClassName="editor"
            editorStyle={{
              border: "1px solid",
              height: "300px",
              width: "100%",
            }}
            localization={{
              locale: "zh_tw",
            }}
            onEditorStateChange={(e) => setEditorState(e)}
          /> */}
        </Grid>
      </CardContent>
      <Divider />
      <CardActions>
        <Grid container justifyContent="center">
          <Button color="primary" variant="contained" onPress={save}>
            儲存
          </Button>
        </Grid>
      </CardActions>
    </Card>
  );
}
